import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { createCustomElement } from '@angular/elements';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './components/terms-of-service/terms-of-service.component';
import { FeesComponent } from './components/fees/fees.component';
import { BrowserSupportComponent } from './components/browser-support/browser-support.component';
import { ConfirmationButtonComponent } from './components/confirmation-button/confirmation-button.component';
import { IconModule } from '../icon/icon.module';
import {StoreModule} from '@ngrx/store';
import {eventFeatureKey, reducer} from '../event/features/event.reducer';
import {EffectsModule} from '@ngrx/effects';
import {EventEffects} from '../event/features/event.effects';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import { LetModule, PushModule } from '@ngrx/component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { CoreModule } from '../core/core.module';
import { ToastModule } from '../toast/toast.module';
import { PaybeeLivestreamComponent } from './components/paybee-livestream/paybee-livestream.component';
import { DialogModule } from 'app/dialog/dialog.module';
import { EventPageEffects } from '../event-page/features/event-page.effects';
import { MdbSelectComponent } from './components/mdb-select/mdb-select.component';
import { MdbInpupComponent } from './components/mdb-inpup/mdb-inpup.component';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { MdbDropdownModule } from 'mdb-angular-ui-kit/dropdown';


@NgModule({
  declarations: [
    PrivacyPolicyComponent,
    TermsOfServiceComponent,
    FeesComponent,
    BrowserSupportComponent,
    ConfirmationButtonComponent,
    PaybeeLivestreamComponent,
    MdbSelectComponent,
    MdbInpupComponent,
  ],
  exports: [
    MdbSelectComponent
  ],
  imports: [
    CommonModule,
    IconModule,
    StoreModule.forRoot({}, {
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
      },
    }),
    StoreModule.forFeature(eventFeatureKey, reducer),
    EffectsModule.forRoot([]),
    EffectsModule.forFeature([EventEffects, EventPageEffects]),
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
    }),
    LetModule,
    PushModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    ClipboardModule,
    CoreModule,
    ToastModule,
    DialogModule,
    MdbSelectModule,
    MdbFormsModule,
    MdbDropdownModule
  ], 
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomElementsModule {
  constructor(injector: Injector) {
    const PrivacyPolicyElement = createCustomElement(PrivacyPolicyComponent, {injector});
    const TermsOfServiceElement = createCustomElement(TermsOfServiceComponent, {injector});
    const FeesElement = createCustomElement(FeesComponent, {injector});
    const BrowserSupportElement = createCustomElement(BrowserSupportComponent, {injector});
    const ConfirmationButtonElement = createCustomElement(ConfirmationButtonComponent, {injector});
    const PaybeeLiveStreamElement = createCustomElement(PaybeeLivestreamComponent, {injector});

    try {
      customElements.define('paybee-privacy-policy-element', PrivacyPolicyElement);
      customElements.define('paybee-terms-of-service-element', TermsOfServiceElement);
      customElements.define('paybee-fees-element', FeesElement);
      customElements.define('paybee-browser-support-element', BrowserSupportElement);
      customElements.define('paybee-confirmation-button-element', ConfirmationButtonElement);
      customElements.define('paybee-live-stream-element', PaybeeLiveStreamElement);
    } catch(e) {}

    // MDB-5

    const PaybeeSelectMDBElement = createCustomElement(MdbSelectComponent, {injector});

    try {
      customElements.define('paybee-mdb-select-element', PaybeeSelectMDBElement);
    } catch(e) {}

  }
}
